<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @selection-change="handleSelectionChange"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" @click.stop="handleAdd">新增分组</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" plain @click.stop="handleDelete">批量删除</el-button>
        </template>
        <!-- 类型徽标列 -->
        <template slot="type" slot-scope="scope">
          <el-tag :color="getTypeColor(scope.row.type) + '20'"
            :style="{ color: getTypeColor(scope.row.type), borderColor: getTypeColor(scope.row.type) }" size="small">
            {{ getTypeLabel(scope.row.type) }}
          </el-tag>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" icon="el-icon-edit" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" icon="el-icon-view" size="small" @click="handleView(scope.row)">查看明细</el-button>
        </template>
      </avue-crud>

      <!-- 新增 / 编辑分组弹窗 -->
      <el-dialog :title="isEdit ? '编辑分组' : '新增分组'" :visible.sync="dialogVisible" width="780px"
        custom-class="ag-dialog" :close-on-click-modal="false" @close="resetForm">
        <el-form :model="formData" :rules="formRules" ref="form" label-width="110px" size="small">
          <!-- 基础信息 -->
          <div class="ag-section ag-section--base">
            <div class="ag-section__head">
              <i class="el-icon-info-circle"></i>
              <span class="ag-section__title">基础信息</span>
            </div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="分组名称" prop="groupName">
                  <el-input v-model="formData.groupName" placeholder="请输入分组名称" maxlength="30" show-word-limit />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分组类型" prop="type">
                  <el-select v-model="formData.type" placeholder="请选择分组类型" style="width: 100%">
                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                      <span :style="{ color: item.color }">● </span>{{ item.label }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="排序" prop="sort">
                  <el-input-number v-model="formData.sort" :min="0" :max="9999" :precision="0"
                    controls-position="right" placeholder="数字越小越靠前" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 计价配置（新增与编辑均可用） -->
          <div class="ag-section ag-section--extra">
            <div class="ag-section__head">
              <i class="el-icon-magic-stick"></i>
              <span class="ag-section__title">计价配置</span>
              <span class="ag-section__desc">
                {{ isEdit ? '归档字段的师傅、商家及交付拆分规则' : '可先添加计价项，保存分组后一并创建' }}
              </span>
              <el-button size="mini" icon="el-icon-connection" plain
                :disabled="laborMergeSelection.length < 2"
                @click="openLaborMergeDialog">设置联合计费</el-button>
              <el-button size="mini" icon="el-icon-close" plain
                :disabled="!hasSelectedLaborMerge"
                @click="clearLaborMergeGroup">取消联合计费</el-button>
              <el-button type="primary" size="mini" icon="el-icon-plus" plain
                @click="openExtraDialog()">添加计价项</el-button>
            </div>
            <el-table ref="extraTable" :data="extraItems" v-loading="extraLoading" size="mini" border stripe
              empty-text="暂无增项配置" @selection-change="onLaborMergeSelectionChange">
              <el-table-column type="selection" width="44" align="center"
                :selectable="isLaborMergeSelectable" />
              <el-table-column label="字段名" prop="fieldName" min-width="140" show-overflow-tooltip />
              <el-table-column label="商户别名" prop="merchantAliasName" min-width="140" show-overflow-tooltip />
              <el-table-column label="计算方式" width="110" align="center">
                <template slot-scope="scope">
                  <el-tag size="mini"
                    :type="{
                      MULTIPLY: 'warning', START_QUANTITY: 'warning', DIRECT: 'success', FIXED: 'info', FIXED_PRESENT: 'info', AREA_TOTAL: 'danger', AREA_ROLE: 'primary', EXCESS: 'warning'
                    }[scope.row.calcType] || 'info'"
                    effect="plain">
                    {{ getCalcTypeLabel(scope.row.calcType) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="师傅联合计费" min-width="160" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.laborMergeGroup" type="warning" size="mini" effect="plain">
                    {{ scope.row.laborMergeName || '联合计费' }}（{{ laborMergeMemberCount(scope.row.laborMergeGroup) }}项）
                    <span v-if="scope.row.laborMergeMode === 'COMPOSITE'">
                      · {{ scope.row.laborMergeRole === 'BASE' ? '主项' : '附加项' }}
                    </span>
                  </el-tag>
                  <span v-else style="color:#c0c4cc">-</span>
                </template>
              </el-table-column>
              <el-table-column label="基础面积角色" width="130" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.waterproofAreaRole" type="primary" size="mini" effect="plain">
                    {{ getWaterproofAreaRoleLabel(scope.row.waterproofAreaRole) }}
                  </el-tag>
                  <span v-else style="color:#c0c4cc">-</span>
                </template>
              </el-table-column>
              <el-table-column label="师傅金额 / 单价" prop="unitPrice" width="130" align="right">
                <template slot-scope="scope">
                  <span v-if="needPriceInput(scope.row.calcType) && scope.row.unitPrice != null">
                    <span style="color:#e6a23c;font-weight:600">{{ scope.row.unitPrice }}</span>
                    <span style="color:#909399"> 元</span>
                  </span>
                  <span v-else style="color:#c0c4cc">-</span>
                </template>
              </el-table-column>
              <el-table-column label="商家价格来源" width="150" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.merchantAreaFlag === 1 && scope.row.calcType === 'DIRECT'"
                    type="success" size="mini" effect="plain">
                    填写金额
                  </el-tag>
                  <el-tag v-else-if="scope.row.merchantAreaFlag === 1 && scope.row.merchantPriceBookType"
                    type="success" size="mini" effect="plain">
                    {{ getMerchantPriceSourceLabel(scope.row.merchantPriceBookType) }} ·
                    {{ getPricingItemLabel(scope.row.merchantPriceItemCode) }}
                  </el-tag>
                  <span v-else-if="scope.row.merchantAreaFlag === 1 && scope.row.merchantUnitPrice != null">
                    <span style="color:#67c23a;font-weight:600">{{ scope.row.merchantUnitPrice }}</span>
                    <span style="color:#909399"> {{ isFixedCalcType(scope.row.calcType) ? '元/次' : '元/单位' }}（分组）</span>
                  </span>
                  <span v-else style="color:#c0c4cc">-</span>
                  <div v-if="scope.row.merchantAreaFlag === 1 && scope.row.merchantStartQuantity != null"
                    style="margin-top:4px;color:#909399;font-size:12px">
                    起算 {{ scope.row.merchantStartQuantity }}
                  </div>
                  <div v-else-if="scope.row.merchantAreaFlag === 1 && scope.row.merchantTierThreshold != null && scope.row.merchantTierBaseAmount != null"
                    style="margin-top:4px;color:#909399;font-size:12px">
                    含 {{ scope.row.merchantTierThreshold }}，保底 {{ scope.row.merchantTierBaseAmount }} 元
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="师傅阈值" width="100" align="right">
                <template slot-scope="scope">
                  <span v-if="['AREA_TOTAL', 'MULTIPLY', 'START_QUANTITY', 'AREA_ROLE', 'EXCESS'].includes(scope.row.calcType) && scope.row.threshold != null && scope.row.threshold !== ''">
                    {{ scope.row.threshold }}
                  </span>
                  <span v-else style="color:#c0c4cc">-</span>
                </template>
              </el-table-column>
              <el-table-column :label="extraMinAmountHeader" width="100" align="right">
                <template slot-scope="scope">
                  <span v-if="scope.row.minAmount != null && scope.row.minAmount !== ''">
                    <span style="color:#f56c6c;font-weight:600">{{ scope.row.minAmount }}</span>
                    <span style="color:#909399"> 元</span>
                  </span>
                  <span v-else style="color:#c0c4cc">-</span>
                </template>
              </el-table-column>
              <el-table-column label="互斥组" width="130" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.mutexGroup" size="mini" effect="plain"
                    :color="getMutexGroupColor(scope.row.mutexGroup) + '20'"
                    :style="{ color: getMutexGroupColor(scope.row.mutexGroup), borderColor: getMutexGroupColor(scope.row.mutexGroup) }">
                    {{ scope.row.mutexGroup }}
                  </el-tag>
                  <span v-else style="color:#c0c4cc">-</span>
                </template>
              </el-table-column>
              <el-table-column label="互斥优先级" width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.mutexGroup">{{ scope.row.mutexPriority }}</span>
                  <span v-else style="color:#c0c4cc">-</span>
                </template>
              </el-table-column>
              <el-table-column label="启用" width="80" align="center">
                <template slot-scope="scope">
                  <el-switch :value="scope.row.enabled === 1"
                    @change="toggleExtraEnabled(scope.row, $event)" />
                </template>
              </el-table-column>
              <el-table-column label="商家费用模式" width="170" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.merchantAreaFlag === 1" type="success" size="mini" effect="plain">
                    <i class="el-icon-money"></i>
                    {{ scope.row.calcType === 'DIRECT'
                      ? '填写金额直接计入'
                      : isFixedCalcType(scope.row.calcType)
                        ? `固定金额·${getMerchantPriceSourceLabel(scope.row.merchantPriceBookType)}`
                        : getMerchantFeeModeLabel(scope.row) }}
                  </el-tag>
                  <el-tag v-else type="info" size="mini" effect="plain">不进商家</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="交付拆分" width="170" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.deliveryFeeCategory" size="mini" effect="plain">
                    {{ getDeliveryFeeCategoryLabel(scope.row.deliveryFeeCategory) }}
                    <template v-if="scope.row.deliveryUnitPrice != null"> · {{ scope.row.deliveryUnitPrice }}元</template>
                  </el-tag>
                  <span v-else style="color:#c0c4cc">旧规则</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="130" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" icon="el-icon-edit"
                    @click="openExtraDialog(scope.row)">编辑</el-button>
                  <el-button type="text" size="mini" icon="el-icon-delete" style="color:#f56c6c"
                    @click="deleteExtra(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 分组明细弹窗 -->
      <group-details :visible="detailVisible" :group-id="currentGroupId" @close="closeDetail" />

      <!-- 增项新增/编辑子弹窗 -->
      <el-dialog :title="extraForm.id ? '编辑增项' : '添加增项'"
        :visible.sync="extraDialogVisible" width="780px" append-to-body :close-on-click-modal="false">
        <el-form :model="extraForm" :rules="extraRules" ref="extraForm" label-width="100px" size="small">
          <el-form-item label="字段名" prop="fieldName">
            <el-input v-model="extraForm.fieldName" placeholder="须与后台动态表单字段名完全一致"
              :disabled="extraForm.calcType === 'AREA_ROLE' && !!extraForm.id"
              maxlength="50" show-word-limit />
            <div v-if="extraForm.calcType === 'AREA_ROLE' && extraForm.id" class="form-tip">
              <i class="el-icon-info"></i>
              为兼容归档旧单，已保存的字段名不能改；字段改名时请新增一条相同角色的配置
            </div>
          </el-form-item>
          <!-- 字段别名 -->
          <el-form-item label="字段别名" prop="alias">
            <el-input v-model="extraForm.aliasName" placeholder="请输入字段别名，不填则显示字段名"
              maxlength="50" show-word-limit />
          </el-form-item>
          <!-- 商户别名 -->
          <el-form-item label="商户别名" prop="merchantAliasName">
            <el-input v-model="extraForm.merchantAliasName" placeholder="请输入商户别名"
              maxlength="50" show-word-limit />
          </el-form-item>
          <el-form-item label="计算方式" prop="calcType">
            <el-tag v-if="isLaborMergedExtra" type="warning" effect="plain">
              {{ getCalcTypeLabel(extraForm.calcType) }}
            </el-tag>
            <el-tag v-else-if="extraForm.calcType === 'AREA_ROLE' && extraForm.id"
              type="primary" effect="plain">
              {{ getCalcTypeLabel(extraForm.calcType) }}
            </el-tag>
            <div v-else class="calc-type-grid">
              <div v-for="opt in calcTypeOptions" :key="opt.value"
                :class="['calc-type-card', { 'is-active': extraForm.calcType === opt.value }]"
                @click="onCalcTypeChange(opt.value)">
                <div class="calc-type-card__icon" :style="{ background: opt.bg, color: opt.color }">
                  <i :class="opt.icon"></i>
                </div>
                <div class="calc-type-card__body">
                  <div class="calc-type-card__title">{{ opt.label }}</div>
                  <div class="calc-type-card__desc">{{ opt.desc }}</div>
                </div>
                <i v-if="extraForm.calcType === opt.value" class="el-icon-success calc-type-card__check"></i>
              </div>
            </div>
            <div v-if="isLaborMergedExtra" class="form-tip">
              <i class="el-icon-info"></i>
              已加入“{{ extraForm.laborMergeName }}”
              <template v-if="extraForm.laborMergeMode === 'COMPOSITE'">，当前字段为{{ extraForm.laborMergeRole === 'BASE' ? '主计费项' : '附加计费项' }}，单价、阈值和保底可单独修改</template>
              <template v-else>，师傅计价参数请通过“设置联合计费”统一修改</template>
            </div>
          </el-form-item>
          <el-form-item v-if="extraForm.laborMergeGroup && extraForm.laborMergeMode === 'COMPOSITE'"
            label="组合角色" prop="laborMergeRole">
            <el-select v-model="extraForm.laborMergeRole" style="width:100%">
              <el-option label="主计费项（保底 + 超出部分）" value="BASE" />
              <el-option label="附加计费项（全部数量 × 单价）" value="ADDITIONAL" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="extraForm.calcType === 'AREA_ROLE'"
            label="基础面积角色" prop="waterproofAreaRole">
            <el-select v-model="extraForm.waterproofAreaRole" clearable style="width: 100%"
              placeholder="请选择该归档字段在防水计算中的业务角色"
              @change="onWaterproofAreaRoleChange">
              <el-option v-for="item in waterproofAreaRoleOptions" :key="item.value"
                :label="item.label" :value="item.value" />
            </el-select>
            <div class="form-tip">
              <i class="el-icon-info"></i>
              字段名负责匹配归档表单，业务角色负责面积汇总及保底规则
            </div>
          </el-form-item>
          <el-form-item v-if="needPriceInput(extraForm.calcType)"
            :label="isFixedCalcType(extraForm.calcType) ? '师傅金额' : '师傅单价'"
            prop="unitPrice">
            <el-input-number v-model="extraForm.unitPrice" :min="0" :precision="2" :step="1"
              controls-position="right"
              :disabled="isLegacyLaborMergedExtra"
              :placeholder="isFixedCalcType(extraForm.calcType) ? '请输入固定金额，如 100' : '请输入单价，如 30'"
              style="width: 100%" />
            <div class="form-tip">
              <i class="el-icon-info"></i>
              {{
                isFixedCalcType(extraForm.calcType) ? '字段满足所选触发方式后按此金额计算（与填入值无关）'
                  : extraForm.calcType === 'AREA_TOTAL' ? '费用 = 面积总计 × 单价'
                    : extraForm.calcType === 'EXCESS' ? '费用 = (填入数量 - 阈值) × 单价'
                      : '费用 = 计费数量 × 单价'
              }}
            </div>
          </el-form-item>
          <el-form-item v-if="['MULTIPLY', 'START_QUANTITY', 'AREA_TOTAL', 'AREA_ROLE', 'EXCESS'].includes(extraForm.calcType)"
            :label="extraForm.calcType === 'START_QUANTITY' ? '师傅起算数量' : (extraForm.calcType === 'MULTIPLY' || extraForm.calcType === 'EXCESS' ? '师傅数量阈值' : '师傅面积阈值')" prop="threshold">
            <el-input-number v-model="extraForm.threshold" :min="0" :precision="2" :step="1"
              controls-position="right"
               :disabled="isLegacyLaborMergedExtra"
              :placeholder="extraForm.calcType === 'START_QUANTITY' ? '必填，低于此数量不收费' : (extraForm.calcType === 'EXCESS' ? '必填，只计算超出此值的数量' : '选填，不填则无阈值')"
              style="width: 100%" />
            <div class="form-tip">
              <i class="el-icon-info"></i>
              <template v-if="extraForm.calcType === 'MULTIPLY'">
                单独填写：数量低于阈值不计费，达到后按完整数量×师傅单价；同时填写保底金额时启用阶梯保底
              </template>
              <template v-else-if="extraForm.calcType === 'START_QUANTITY'">
                数量低于起算数量不收费，达到起算数量后按完整数量 × 师傅单价计算
              </template>
              <template v-else-if="extraForm.calcType === 'EXCESS'">
                数量超过阈值后，只对超出的部分计费
              </template>
              <template v-else-if="extraForm.calcType === 'AREA_ROLE'">
                回填/基坑表示本字段保底面积；面层表示同报单基坑+面层合计保底面积
              </template>
              <template v-else>
                面积总计 < 阈值时按阈值计费，不填则不保底
              </template>
            </div>
          </el-form-item>
          <!-- 保底金额 / 最低结算金额：MULTIPLY 为阈值保底联动，其他模式为最低结算金额 -->
          <el-form-item v-if="extraForm.calcType === 'MULTIPLY'" label="师傅保底金额" prop="minAmount">
            <el-input-number v-model="extraForm.minAmount" :min="0" :precision="2" :step="1"
              controls-position="right" :disabled="isLegacyLaborMergedExtra"
              placeholder="选填，不填则无保底" style="width: 100%" />
            <div class="form-tip">
              <i class="el-icon-info"></i>
              单独填写时：费用 = max(数量 × 单价, 保底金额)；同时填写数量阈值时启用阶梯计价
            </div>
          </el-form-item>
          <el-form-item v-else-if="needPriceInput(extraForm.calcType) && extraForm.calcType !== 'START_QUANTITY'" label="师傅价格阈值" prop="minAmount">
            <el-input-number v-model="extraForm.minAmount" :min="0" :precision="2" :step="1"
              controls-position="right"
              placeholder="选填，计算金额低于此值时按此值计费"
              style="width: 100%" />
            <div class="form-tip">
              <i class="el-icon-info"></i>
              计算金额 < 价格阈值时按阈值计费（最低保底金额），不填则不保底
            </div>
          </el-form-item>
          <el-form-item label="启用" prop="enabled">
            <el-switch :value="extraForm.enabled === 1"
              @change="extraForm.enabled = $event ? 1 : 0" />
          </el-form-item>
          <el-form-item v-if="extraForm.calcType !== 'AREA_ROLE'"
            :label="extraForm.calcType === 'DIRECT' ? '计入商家费用' : '商家独立计价'">
            <el-switch :value="extraForm.merchantAreaFlag === 1"
              @change="onMerchantAreaFlagChange" />
            <div class="form-tip" style="margin-top:0;display:inline-block;margin-left:10px">
              <i class="el-icon-info"></i>
              {{ extraForm.calcType === 'DIRECT'
                ? '开启后将填写金额直接计入商家费用，不需要配置商家单价'
                : isFixedCalcType(extraForm.calcType)
                  ? '开启后字段生效即按商家固定金额计费，不读取字段值或师傅固定金额'
                  : '开启后按字段数量和商家价格计算，不使用师傅单价' }}
            </div>
          </el-form-item>
          <el-form-item v-if="extraForm.merchantAreaFlag === 1 && extraForm.calcType !== 'DIRECT'"
            label="商家价格来源">
            <el-select v-model="extraForm.merchantPriceBookType" style="width: 100%"
              @change="onMerchantPriceSourceChange"
              placeholder="请选择商家价格来源">
              <el-option v-for="item in merchantPriceSourceOptions" :key="item.value"
                :label="item.label" :value="item.value" />
            </el-select>
            <div class="form-tip">
              <i class="el-icon-info"></i>
              价目表价格按当前商户自动匹配，字段名称变更不会影响价格来源
            </div>
          </el-form-item>
          <el-form-item v-if="extraForm.merchantAreaFlag === 1 && extraForm.calcType !== 'DIRECT' && !isFixedCalcType(extraForm.calcType)"
            label="商家数量规则">
            <el-select v-model="extraForm.merchantQuantityRule" style="width: 100%"
              @change="onMerchantQuantityRuleChange">
              <el-option label="普通计价（全部数量 × 单价）" value="NORMAL" />
              <el-option label="起算数量（低于不收，达到后全部计价）" value="START" />
              <el-option label="阶梯保底（含固定数量，超出按单价）" value="TIER" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="extraForm.merchantAreaFlag === 1 && extraForm.calcType !== 'DIRECT' && !isFixedCalcType(extraForm.calcType) && extraForm.merchantQuantityRule === 'START'"
            label="商家起算数量" prop="merchantStartQuantity">
            <el-input-number v-model="extraForm.merchantStartQuantity" :min="0.01" :precision="2" :step="1"
              controls-position="right" placeholder="请输入起算数量" style="width: 100%" />
            <div class="form-tip">
              <i class="el-icon-info"></i>
              数量低于此值不产生商家费用；达到后按完整数量 × 商家价格计算
            </div>
          </el-form-item>
          <template v-if="extraForm.merchantAreaFlag === 1 && extraForm.calcType !== 'DIRECT' && !isFixedCalcType(extraForm.calcType) && extraForm.merchantQuantityRule === 'TIER'">
            <el-form-item label="商家阶梯阈值" prop="merchantTierThreshold">
              <el-input-number v-model="extraForm.merchantTierThreshold" :min="0.01" :precision="2" :step="1"
                controls-position="right" placeholder="请输入固定金额包含的数量，如 2" style="width: 100%" />
            </el-form-item>
            <el-form-item label="商家保底金额" prop="merchantTierBaseAmount">
              <el-input-number v-model="extraForm.merchantTierBaseAmount" :min="0.01" :precision="2" :step="1"
                controls-position="right" placeholder="请输入阈值内固定金额，如 100" style="width: 100%" />
              <div class="form-tip">
                <i class="el-icon-info"></i>
                数量不超过阈值按保底金额；超过后费用 = 保底金额 +（数量 - 阈值）× 商家价格
              </div>
            </el-form-item>
          </template>
          <el-form-item v-if="extraForm.merchantAreaFlag === 1 && extraForm.calcType !== 'DIRECT' && extraForm.merchantPriceBookType"
            label="价盘计价项" prop="merchantPriceItemCode">
            <el-select v-model="extraForm.merchantPriceItemCode" filterable allow-create default-first-option
              placeholder="请选择或输入稳定编码" style="width: 100%">
              <el-option v-for="item in availablePricingItemOptions" :key="item.value"
                :label="`${item.label}（${item.value}）`" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="extraForm.merchantAreaFlag === 1 && extraForm.calcType !== 'DIRECT'"
            :label="isFixedCalcType(extraForm.calcType)
              ? (extraForm.merchantPriceBookType ? '商家兜底固定金额' : '商家固定金额')
              : (extraForm.merchantPriceBookType ? '商家兜底单价' : '商家独立单价')"
            prop="merchantUnitPrice">
            <el-input-number v-model="extraForm.merchantUnitPrice" :min="0.01" :precision="2" :step="1"
              controls-position="right"
              :placeholder="isFixedCalcType(extraForm.calcType)
                ? (extraForm.merchantPriceBookType ? '选填，商户未配置时使用' : '请输入商家固定金额')
                : (extraForm.merchantPriceBookType ? '选填，商户计价项未配置时使用' : '请输入商家独立单价')"
              style="width: 100%" />
            <div class="form-tip" style="margin-top: 4px">
              <i class="el-icon-info"></i>
              {{ isFixedCalcType(extraForm.calcType)
                ? (extraForm.merchantPriceBookType
                  ? '价盘未匹配时使用此固定金额；不填则跳过并提示'
                  : '商家费用 = 此固定金额，与师傅固定金额相互独立')
                : (extraForm.merchantPriceBookType
                  ? '商户没有配置该计价项时使用此单价；不填则跳过并提示'
                  : '商家费用 = 字段数量 × 此单价，与师傅金额/单价相互独立') }}
            </div>
          </el-form-item>
          <el-form-item label="交付拆分归类" prop="deliveryFeeCategory">
            <el-select v-model="extraForm.deliveryFeeCategory" clearable style="width: 100%"
              placeholder="不配置则兼容旧拆分规则">
              <el-option v-for="item in deliveryFeeCategoryOptions" :key="item.value"
                :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="extraForm.calcType !== 'DIRECT' && extraForm.deliveryFeeCategory && extraForm.deliveryFeeCategory !== 'IGNORE'"
            :label="isFixedCalcType(extraForm.calcType) ? '交付拆分固定金额' : '交付拆分单价'"
            prop="deliveryUnitPrice">
            <el-input-number v-model="extraForm.deliveryUnitPrice" :min="0.01" :precision="2" :step="1"
              controls-position="right"
              :placeholder="isFixedCalcType(extraForm.calcType) ? '选填，不填使用师傅固定金额' : '请输入交付拆分单价'"
              style="width: 100%" />
            <div class="form-tip">
              <i class="el-icon-info"></i>
              {{ isFixedCalcType(extraForm.calcType)
                ? '字段生效即按此固定金额拆分；不填则使用师傅固定金额'
                : '配置后按冻结数量 × 此单价拆分，不再读取师傅单价' }}
            </div>
          </el-form-item>
          <!-- 互斥配置 -->
          <div class="mutex-section">
            <div class="mutex-section__head">
              <i class="el-icon-connection"></i>
              <span class="mutex-section__title">互斥配置</span>
              <span class="mutex-section__desc">同分组下填相同互斥组标识的多个增项互斥择一计费</span>
            </div>
            <div class="mutex-section__tip">
              <i class="el-icon-info"></i>
              同分组下，互斥组填相同标识的多个增项是互相替代关系。例如「丙纶施工面积」和「楼下防水区域顶棚照片」填同一个互斥组，则丙纶有值时只算丙纶，丙纶没值才算照片项。
            </div>
            <el-row :gutter="16">
              <el-col :span="14">
                <el-form-item label="互斥组标识" prop="mutexGroup">
                  <el-input v-model="extraForm.mutexGroup"
                    placeholder="留空表示不参与互斥，同分组下相同标识的增项互斥择一"
                    maxlength="50" show-word-limit clearable />
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="互斥优先级" prop="mutexPriority">
                  <el-input-number v-model="extraForm.mutexPriority" :min="0" :max="9999" :precision="0"
                    controls-position="right" placeholder="数值越小越优先，默认0"
                    style="width: 100%" :disabled="!extraForm.mutexGroup" />
                  <div class="form-tip">
                    <i class="el-icon-info"></i>
                    数值越小越优先，同组内多个都有值时按此排序取首个
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="extraDialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="extraSubmitLoading" @click="submitExtra">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="设置师傅联合计费" :visible.sync="laborMergeDialogVisible"
        width="560px" append-to-body :close-on-click-modal="false">
        <el-form ref="laborMergeForm" :model="laborMergeForm" :rules="laborMergeRules"
          label-width="120px" size="small">
          <el-form-item label="已选字段">
            <el-tag v-for="item in laborMergeSelection" :key="item.id || item._localId || item.fieldName"
              size="mini" effect="plain" style="margin:0 6px 6px 0">
              {{ item.fieldName }}
            </el-tag>
          </el-form-item>
          <el-form-item label="联合计费名称" prop="mergeName">
            <el-input v-model="laborMergeForm.mergeName" maxlength="64" show-word-limit
              placeholder="例如：组合人工费" />
          </el-form-item>
          <el-form-item label="联合计费规则" prop="mergeMode">
            <el-radio-group v-model="laborMergeForm.mergeMode">
              <el-radio label="LEGACY">旧联合计费</el-radio>
              <el-radio label="COMPOSITE">组合计费</el-radio>
            </el-radio-group>
            <div class="form-tip" v-if="laborMergeForm.mergeMode === 'COMPOSITE'">
              同时填写多个字段时，主计费项按自己的阈值/保底计算，其他字段按各自单价计算；只填写一个字段时使用该字段自己的规则。
            </div>
          </el-form-item>
          <el-form-item v-if="laborMergeForm.mergeMode === 'COMPOSITE'" label="主计费项" prop="baseItemId">
            <el-select v-model="laborMergeForm.baseItemId" style="width:100%" placeholder="请选择主计费项">
              <el-option v-for="item in laborMergeSelection" :key="item.id || item._localId || item.fieldName"
                :label="item.fieldName" :value="item.id || item._localId" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="laborMergeForm.mergeMode !== 'COMPOSITE'" label="师傅单价" prop="unitPrice">
            <el-input-number v-model="laborMergeForm.unitPrice" :min="0.01" :precision="2"
              :step="1" controls-position="right" style="width:100%" />
          </el-form-item>
          <el-form-item v-if="laborMergeForm.mergeMode !== 'COMPOSITE'" label="师傅保底金额" prop="minAmount">
            <el-input-number v-model="laborMergeForm.minAmount" :min="0.01" :precision="2"
              :step="1" controls-position="right" style="width:100%" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="laborMergeDialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="laborMergeSubmitting"
            @click="submitLaborMergeGroup">确 定</el-button>
        </div>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { userTableOption, groupTypeDic } from "@/const/salesCloud/accountGroupOption";
import {
  findUser,
  addTask,
  editAcct,
  deleteAccountGroup,
  findExtraItem,
  addExtraItem,
  updateExtraItem,
  setLaborMergeGroup,
  deleteExtraItem,
} from "@/api/sales/accountGroup";
import { getRootDepartmentId } from "@/api/work/waterProof/merchants";
import GroupDetails from "./groupDetails.vue";

const buildEmptyForm = () => {
  return {
    id: "",
    groupName: "",
    sort: 0,
    type: "",
    rootDepartId: "",
  };
};

const buildEmptyExtraForm = () => ({
  id: "",
  fieldName: "",
  aliasName: "",
  laborMergeGroup: "",
  laborMergeName: "",
  laborMergeMode: "",
  laborMergeRole: "",
  merchantAliasName: "",
  calcType: "DIRECT",
  unitPrice: 0,
  merchantUnitPrice: null,
  merchantPriceBookType: "",
  merchantPriceItemCode: "",
  merchantQuantityRule: "NORMAL",
  merchantStartQuantity: null,
  merchantTierThreshold: null,
  merchantTierBaseAmount: null,
  waterproofAreaRole: "",
  deliveryFeeCategory: "",
  deliveryUnitPrice: null,
  threshold: null,
  enabled: 1,
  includeInMerchant: 0,
  merchantAreaFlag: 0,
  groupId: "",
  mutexGroup: "",
  mutexPriority: 0,
  minAmount: null,
});

export default {
  name: "accountGroup",
  components: { GroupDetails },
  data() {
    return {
      tableOption: userTableOption,
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      submitLoading: false,
      isEdit: false,
      formData: buildEmptyForm(),
      typeOptions: groupTypeDic,
      formRules: {
        groupName: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择分组类型", trigger: "change" }],
      },
      page: { total: 0, currentPage: 1, pageSize: 10 },
      detailVisible: false,
      currentGroupId: "",
      // 缓存搜索条件
      searchParams: {},
      // 顶级部门 ID
      rootDepartId: "",
      /* ====== 增项配置 ====== */
      extraItems: [],
      extraLoading: false,
      extraDialogVisible: false,
      extraSubmitLoading: false,
      extraForm: buildEmptyExtraForm(),
      laborMergeSelection: [],
      laborMergeDialogVisible: false,
      laborMergeSubmitting: false,
      laborMergeForm: {
        mergeName: "",
        mergeMode: "LEGACY",
        baseItemId: null,
        unitPrice: null,
        minAmount: null,
      },
      laborMergeRules: {
        mergeName: [
          { required: true, message: "请输入联合计费名称", trigger: "blur" },
          { max: 64, message: "联合计费名称不能超过64个字符", trigger: "blur" },
        ],
        mergeMode: [{ required: true, message: "请选择联合计费规则", trigger: "change" }],
        baseItemId: [{ required: true, message: "请选择主计费项", trigger: "change" }],
        unitPrice: [
          { required: true, message: "请输入师傅单价", trigger: "blur" },
        ],
        minAmount: [
          { required: true, message: "请输入师傅保底金额", trigger: "blur" },
        ],
      },
      merchantPriceSourceOptions: [
        { label: "分组配置单价", value: "" },
        { label: "防水价目表", value: "WATERPROOF" },
        { label: "回填价目表", value: "BACKFILL" },
      ],
      pricingItemOptions: [
        { label: "基础面积", value: "BASE_AREA", projectTypes: ["WATERPROOF", "BACKFILL", "HANG_CEILING"] },
        { label: "二排", value: "SECOND_DRAIN", projectTypes: ["BACKFILL"] },
        { label: "模具施工个数", value: "MOLD", projectTypes: ["BACKFILL"] },
        { label: "丙纶施工面积", value: "POLYPROPYLENE_AREA", projectTypes: ["WATERPROOF"] },
        { label: "步梯楼层数", value: "STAIR_FLOOR", projectTypes: ["BACKFILL"] },
        { label: "二次上门增加施工面积", value: "SECOND_VISIT_AREA", projectTypes: ["WATERPROOF"] },
      ],
      deliveryFeeCategoryOptions: [
        { label: "单独明细", value: "DETAIL" },
        { label: "合并到增项", value: "ADDITION" },
        { label: "基础面积", value: "BASE_AREA" },
        { label: "丙纶", value: "POLYPROPYLENE" },
        { label: "不计入拆分", value: "IGNORE" },
      ],
      waterproofAreaRoleOptions: [
        { label: "回填面积", value: "BACKFILL_AREA" },
        { label: "基坑防水面积", value: "BASE_PIT_AREA" },
        { label: "面层防水面积", value: "SURFACE_AREA" },
      ],
      calcTypeOptions: [
        {
          value: "DIRECT", label: "填多少算多少", desc: "用户填入的数值即为费用",
          icon: "el-icon-edit-outline", color: "#67c23a", bg: "#f0f9eb",
        },
        {
          value: "MULTIPLY", label: "数量 × 单价", desc: "按实际填写数量 × 单价计算",
          icon: "el-icon-edit-outline", color: "#e6a23c", bg: "#fdf6ec",
        },
        {
          value: "START_QUANTITY", label: "起算数量", desc: "低于起算数量不收费，达到后按完整数量 × 单价计算",
          icon: "el-icon-top", color: "#f56c6c", bg: "#fef0f0",
        },
        {
          value: "FIXED", label: "选中时固定金额", desc: "仅选择是、选中或开启时计固定金额",
          icon: "el-icon-edit-outline", color: "#909399", bg: "#f4f4f5",
        },
        {
          value: "FIXED_PRESENT", label: "填写即固定金额", desc: "字段只要有填写值即计固定金额，包括选择否",
          icon: "el-icon-edit-outline", color: "#606266", bg: "#f4f4f5",
        },
        {
          value: "AREA_TOTAL", label: "面积总计 × 单价", desc: "按总面积 × 单价计算",
          icon: "el-icon-edit-outline", color: "#f56c6c", bg: "#fef0f0",
        },
        {
          value: "AREA_ROLE", label: "防水基础面积", desc: "按业务角色套用回填、基坑或面层公式",
          icon: "el-icon-map-location", color: "#409eff", bg: "#ecf5ff",
        },
        {
          value: "EXCESS", label: "超出阈值 × 单价", desc: "只按超出阈值的数量计费",
          icon: "el-icon-top", color: "#e6a23c", bg: "#fdf6ec",
        },
      ],
      extraRules: {
        fieldName: [
          { required: true, message: "请输入字段名", trigger: "blur" },
          { max: 50, message: "字段名不能超过 50 个字符", trigger: "blur" },
        ],
        calcType: [{ required: true, message: "请选择计算方式", trigger: "change" }],
        waterproofAreaRole: [
          {
            validator: (rule, value, callback) => {
              if (this.extraForm.calcType === "AREA_ROLE" && !value) {
                callback(new Error("请选择基础面积角色"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        unitPrice: [
          {
            validator: (rule, value, callback) => {
              const t = this.extraForm.calcType;
              if (this.needPriceInput(t) && (value === null || value === undefined || value === "")) {
                callback(new Error(this.isFixedCalcType(t) ? "请输入固定金额" : "请输入单价"));
              } else if (t === "START_QUANTITY" && Number(value) <= 0) {
                callback(new Error("请输入大于0的师傅单价"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        merchantUnitPrice: [
          {
            validator: (rule, value, callback) => {
              if (this.extraForm.calcType !== "DIRECT" && this.extraForm.merchantAreaFlag === 1 && !this.extraForm.merchantPriceBookType &&
                (value === null || value === undefined || value === "" || Number(value) <= 0)) {
                callback(new Error(this.isFixedCalcType(this.extraForm.calcType)
                  ? "请输入大于0的商家固定金额" : "请输入大于0的商家独立单价"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        merchantPriceItemCode: [
          {
            validator: (rule, value, callback) => {
              if (this.extraForm.calcType !== "DIRECT" && this.extraForm.merchantAreaFlag === 1 && this.extraForm.merchantPriceBookType && !value) {
                callback(new Error("请选择或输入价盘计价项"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        merchantStartQuantity: [
          {
            validator: (rule, value, callback) => {
              if (this.extraForm.merchantQuantityRule === "START" &&
                (value === null || value === undefined || value === "" || Number(value) <= 0)) {
                callback(new Error("请输入大于0的商家起算数量"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        merchantTierThreshold: [
          {
            validator: (rule, value, callback) => {
              if (this.extraForm.merchantQuantityRule === "TIER" &&
                (value === null || value === undefined || value === "" || Number(value) <= 0)) {
                callback(new Error("请输入大于0的商家阶梯阈值"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        merchantTierBaseAmount: [
          {
            validator: (rule, value, callback) => {
              if (this.extraForm.merchantQuantityRule === "TIER" &&
                (value === null || value === undefined || value === "" || Number(value) <= 0)) {
                callback(new Error("请输入大于0的商家保底金额"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        threshold: [
          {
            validator: (rule, value, callback) => {
              const required = this.extraForm.calcType === "EXCESS"
                || this.extraForm.calcType === "START_QUANTITY";
              if (required && (value === null || value === undefined || value === "" || Number(value) <= 0)) {
                callback(new Error(this.extraForm.calcType === "START_QUANTITY"
                  ? "请输入大于0的起算数量" : "请输入大于0的数量阈值"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        deliveryUnitPrice: [
          {
            validator: (rule, value, callback) => {
              const isAreaRole = this.extraForm.calcType === "AREA_ROLE";
              if (isAreaRole && this.extraForm.deliveryFeeCategory !== "IGNORE" &&
                (value === null || value === undefined || value === "" || Number(value) <= 0)) {
                callback(new Error("基础面积必须配置交付拆分单价"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    // 增项表格中「保底金额」列的标题：含 MULTIPLY 时强调阈值保底
    extraMinAmountHeader() {
      const hasMultiply = (this.extraItems || []).some((i) => i.calcType === "MULTIPLY");
      return hasMultiply ? "师傅保底金额" : "师傅价格阈值";
    },
    isLaborMergedExtra() {
      return !!this.extraForm.laborMergeGroup;
    },
    isLegacyLaborMergedExtra() {
      return !!this.extraForm.laborMergeGroup
        && this.extraForm.laborMergeMode !== "COMPOSITE";
    },
    availablePricingItemOptions() {
      const projectType = this.extraForm.merchantPriceBookType;
      if (!projectType) return this.pricingItemOptions;
      return this.pricingItemOptions.filter((item) =>
        !item.projectTypes || item.projectTypes.includes(projectType));
    },
    hasSelectedLaborMerge() {
      return this.laborMergeSelection.some((item) => !!item.laborMergeGroup);
    },
  },
  created() {
    this.fetchRootDepartId();
    this.handleList();
  },
  methods: {
    // 计算方式是否需要金额/单价输入
    needPriceInput(t) {
      return ["MULTIPLY", "START_QUANTITY", "AREA_TOTAL", "FIXED", "FIXED_PRESENT", "AREA_ROLE", "EXCESS"].includes(t);
    },
    isFixedCalcType(t) {
      return t === "FIXED" || t === "FIXED_PRESENT";
    },
    needThresholdInput(t) {
      return ["MULTIPLY", "START_QUANTITY", "AREA_TOTAL", "AREA_ROLE", "EXCESS"].includes(t);
    },
    getCalcTypeLabel(type) {
      const item = this.calcTypeOptions.find((option) => option.value === type);
      return item ? item.label : type || "-";
    },
    isLaborMergeSelectable(row) {
      return row && row.calcType === "MULTIPLY";
    },
    onLaborMergeSelectionChange(selection) {
      this.laborMergeSelection = selection || [];
    },
    laborMergeMemberCount(group) {
      if (!group) return 0;
      return (this.extraItems || []).filter((item) => item.laborMergeGroup === group).length;
    },
    clearLaborMergeSelection() {
      this.laborMergeSelection = [];
      if (this.$refs.extraTable) this.$refs.extraTable.clearSelection();
    },
    expandLaborMergeSelection(selection) {
      const selected = selection || [];
      const selectedGroups = new Set(
        selected.map((item) => item.laborMergeGroup).filter((group) => !!group)
      );
      if (!selectedGroups.size) return selected.slice();
      return (this.extraItems || []).filter(
        (item) => selected.includes(item) || selectedGroups.has(item.laborMergeGroup)
      );
    },
    openLaborMergeDialog() {
      if (this.laborMergeSelection.length < 2) {
        this.$message.warning("请至少选择两个数量乘单价的计费项");
        return;
      }
      this.laborMergeSelection = this.expandLaborMergeSelection(this.laborMergeSelection);
      const first = this.laborMergeSelection[0];
      const sameGroup = !!first.laborMergeGroup && this.laborMergeSelection.every(
        (item) => item.laborMergeGroup === first.laborMergeGroup
      );
      const sameUnitPrice = this.laborMergeSelection.every(
        (item) => Number(item.unitPrice) === Number(first.unitPrice)
      );
      const sameMinAmount = this.laborMergeSelection.every(
        (item) => Number(item.minAmount) === Number(first.minAmount)
      );
      const composite = first.laborMergeMode === "COMPOSITE"
        && this.laborMergeSelection.every((item) => item.laborMergeMode === "COMPOSITE");
      const baseItem = this.laborMergeSelection.find((item) => item.laborMergeRole === "BASE");
      this.laborMergeForm = {
        mergeName: sameGroup ? (first.laborMergeName || "") : "",
        mergeMode: composite ? "COMPOSITE" : "LEGACY",
        baseItemId: composite && baseItem ? (baseItem.id || baseItem._localId) : null,
        unitPrice: sameUnitPrice && first.unitPrice != null ? Number(first.unitPrice) : null,
        minAmount: sameMinAmount && first.minAmount != null ? Number(first.minAmount) : null,
      };
      this.laborMergeDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.laborMergeForm) this.$refs.laborMergeForm.clearValidate();
      });
    },
    submitLaborMergeGroup() {
      this.$refs.laborMergeForm.validate((valid) => {
        if (!valid) return;
        const composite = this.laborMergeForm.mergeMode === "COMPOSITE";
        if (!composite && (Number(this.laborMergeForm.unitPrice) <= 0 || Number(this.laborMergeForm.minAmount) <= 0)) {
          this.$message.warning("师傅单价和保底金额必须大于0");
          return;
        }
        const selected = this.laborMergeSelection.slice();
        if (!this.formData.id) {
          const firstGroup = selected[0].laborMergeGroup;
          const sameGroup = !!firstGroup && selected.every((item) => item.laborMergeGroup === firstGroup);
          const mergeGroup = sameGroup
            ? firstGroup
            : `LMG_LOCAL_${Date.now()}_${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
          selected.forEach((item) => {
            this.$set(item, "laborMergeGroup", mergeGroup);
            this.$set(item, "laborMergeName", this.laborMergeForm.mergeName.trim());
            this.$set(item, "laborMergeMode", composite ? "COMPOSITE" : "LEGACY");
            this.$set(item, "laborMergeRole", composite
              ? ((item.id || item._localId) === this.laborMergeForm.baseItemId ? "BASE" : "ADDITIONAL") : "");
            if (!composite) {
              this.$set(item, "unitPrice", Number(this.laborMergeForm.unitPrice));
              this.$set(item, "minAmount", Number(this.laborMergeForm.minAmount));
              this.$set(item, "threshold", null);
            }
          });
          this.laborMergeDialogVisible = false;
          this.clearLaborMergeSelection();
          this.$message.success("联合计费已设置，将随分组一并保存");
          return;
        }
        this.laborMergeSubmitting = true;
        setLaborMergeGroup({
          groupId: Number(this.formData.id),
          itemIds: selected.map((item) => item.id),
          mergeName: this.laborMergeForm.mergeName.trim(),
          mergeMode: this.laborMergeForm.mergeMode,
          baseItemId: composite ? Number(this.laborMergeForm.baseItemId) : null,
          unitPrice: composite ? null : Number(this.laborMergeForm.unitPrice),
          minAmount: composite ? null : Number(this.laborMergeForm.minAmount),
          clear: false,
        })
          .then((res) => {
            if (res.code === "200") {
              this.$message.success("联合计费设置成功");
              this.laborMergeDialogVisible = false;
              this.clearLaborMergeSelection();
              this.loadExtraItems();
            } else {
              this.$message.error(res.message || "联合计费设置失败");
            }
          })
          .catch(() => this.$message.error("联合计费设置异常"))
          .finally(() => { this.laborMergeSubmitting = false; });
      });
    },
    clearLaborMergeGroup() {
      const selected = this.expandLaborMergeSelection(this.laborMergeSelection)
        .filter((item) => !!item.laborMergeGroup);
      if (!selected.length) return;
      this.$confirm("确定取消所选计费项的师傅联合计费吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (!this.formData.id) {
          selected.forEach((item) => {
            this.$set(item, "laborMergeGroup", "");
            this.$set(item, "laborMergeName", "");
            this.$set(item, "laborMergeMode", "");
            this.$set(item, "laborMergeRole", "");
          });
          this.clearLaborMergeSelection();
          this.$message.success("已取消联合计费");
          return;
        }
        return setLaborMergeGroup({
          groupId: Number(this.formData.id),
          itemIds: selected.map((item) => item.id),
          clear: true,
        }).then((res) => {
          if (res.code === "200") {
            this.$message.success("已取消联合计费");
            this.clearLaborMergeSelection();
            this.loadExtraItems();
          } else {
            this.$message.error(res.message || "取消联合计费失败");
          }
        });
      }).catch((err) => {
        if (err !== "cancel" && err !== "close") {
          this.$message.error("取消联合计费异常");
        }
      });
    },
    getWaterproofAreaRoleLabel(role) {
      const item = this.waterproofAreaRoleOptions.find((option) => option.value === role);
      return item ? item.label : role || "-";
    },
    getMerchantPriceSourceLabel(type) {
      const item = this.merchantPriceSourceOptions.find((option) => option.value === (type || ""));
      return item ? item.label : type || "分组配置单价";
    },
    getPricingItemLabel(code) {
      const normalized = String(code || "BASE_AREA").toUpperCase();
      const item = this.pricingItemOptions.find((option) => option.value === normalized);
      return item ? item.label : normalized;
    },
    normalizePricingItemCode(projectType, code) {
      const normalized = String(code || "").trim().toUpperCase();
      const options = this.pricingItemOptions.filter((item) =>
        !projectType || !item.projectTypes || item.projectTypes.includes(projectType));
      if (!normalized) return options.length ? options[0].value : "BASE_AREA";
      const known = this.pricingItemOptions.find((item) => item.value === normalized);
      if (known && !options.some((item) => item.value === normalized)) {
        return options.length ? options[0].value : "BASE_AREA";
      }
      return normalized;
    },
    onMerchantPriceSourceChange(type) {
      this.extraForm.merchantPriceItemCode = type
        ? this.normalizePricingItemCode(type, this.extraForm.merchantPriceItemCode)
        : "";
    },
    getDeliveryFeeCategoryLabel(category) {
      const item = this.deliveryFeeCategoryOptions.find((option) => option.value === category);
      return item ? item.label : category || "旧规则";
    },
    getMerchantFeeModeLabel(row) {
      const source = this.getMerchantPriceSourceLabel(row.merchantPriceBookType);
      if (row.merchantTierThreshold != null && row.merchantTierBaseAmount != null) {
        return `阶梯保底·${source}`;
      }
      if (row.merchantStartQuantity != null) {
        return `起算数量·${source}`;
      }
      return `数量×${source}`;
    },
    onMerchantQuantityRuleChange(rule) {
      if (rule !== "START") this.extraForm.merchantStartQuantity = null;
      if (rule !== "TIER") {
        this.extraForm.merchantTierThreshold = null;
        this.extraForm.merchantTierBaseAmount = null;
      }
    },
    onCalcTypeChange(type) {
      this.extraForm.calcType = type;
      if (type === "AREA_ROLE") {
        this.extraForm.includeInMerchant = 0;
        this.extraForm.merchantAreaFlag = 0;
        if (this.extraForm.unitPrice == null) this.extraForm.unitPrice = 0;
        this.extraForm.merchantUnitPrice = null;
        this.extraForm.merchantPriceBookType = "";
        this.extraForm.merchantPriceItemCode = "";
        this.extraForm.merchantStartQuantity = null;
        this.extraForm.merchantQuantityRule = "NORMAL";
        this.extraForm.merchantTierThreshold = null;
        this.extraForm.merchantTierBaseAmount = null;
        this.extraForm.deliveryFeeCategory = this.extraForm.waterproofAreaRole === "BACKFILL_AREA"
          ? "DETAIL" : "BASE_AREA";
      } else {
        this.extraForm.waterproofAreaRole = "";
        if (type === "START_QUANTITY") {
          // 起算数量不支持最低结算金额，避免从旧配置带入保底规则。
          this.extraForm.minAmount = null;
        } else if (type === "DIRECT") {
          this.extraForm.unitPrice = null;
          this.extraForm.threshold = null;
          this.extraForm.minAmount = null;
          this.extraForm.merchantUnitPrice = null;
          this.extraForm.merchantPriceBookType = "";
          this.extraForm.merchantPriceItemCode = "";
          this.extraForm.merchantQuantityRule = "NORMAL";
          this.extraForm.merchantStartQuantity = null;
          this.extraForm.merchantTierThreshold = null;
          this.extraForm.merchantTierBaseAmount = null;
          this.extraForm.deliveryUnitPrice = null;
        } else if (this.isFixedCalcType(type)) {
          this.extraForm.merchantStartQuantity = null;
          this.extraForm.merchantQuantityRule = "NORMAL";
          this.extraForm.merchantTierThreshold = null;
          this.extraForm.merchantTierBaseAmount = null;
        }
      }
    },
    onWaterproofAreaRoleChange(role) {
      if (this.extraForm.calcType === "AREA_ROLE") {
        this.extraForm.deliveryFeeCategory = role === "BACKFILL_AREA" ? "DETAIL" : "BASE_AREA";
      }
    },
    /* ====== 顶级部门 ID ====== */
    fetchRootDepartId() {
      if (this.rootDepartId) return Promise.resolve(this.rootDepartId);
      return getRootDepartmentId()
        .then((res) => {
          this.rootDepartId = res && res.data ? res.data : "";
          return this.rootDepartId;
        })
        .catch((err) => {
          console.log("fetchRootDepartId error:", err);
          return "";
        });
    },
    /* ====== 类型 / 标签 / 颜色 ====== */
    getTypeLabel(type) {
      const item = groupTypeDic.find((i) => i.value === type);
      return item ? item.label : type || "-";
    },
    getTypeColor(type) {
      const item = groupTypeDic.find((i) => i.value === type);
      return item ? item.color : "#909399";
    },
    /* ====== 表单 ====== */
    resetForm() {
      this.formData = buildEmptyForm();
      this.isEdit = false;
      this.extraItems = [];
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    handleAdd() {
      this.resetForm();
      this.fetchRootDepartId();
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.resetForm();
      this.isEdit = true;
      // 回显基础字段
      this.formData.id = row.id;
      this.formData.groupName = row.groupName || "";
      this.formData.sort = Number(row.sort) || 0;
      this.formData.type = row.type || "";
      this.formData.rootDepartId = row.rootDepartId || "";
      // 优先使用行数据的 rootDepartId，未返回时则拉取当前部门
      if (!this.rootDepartId && row.rootDepartId) {
        this.rootDepartId = row.rootDepartId;
      } else if (!this.rootDepartId) {
        this.fetchRootDepartId();
      }
      this.dialogVisible = true;
      // 加载增项配置
      this.loadExtraItems();
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        // 分组只保存基础信息，价格统一由计价配置维护。
        const data = {
          groupName: this.formData.groupName,
          sort: this.formData.sort,
          type: this.formData.type,
          rootDepartId: this.rootDepartId || this.formData.rootDepartId || "",
        };
        if (this.isEdit) data.id = this.formData.id;
        this.submitLoading = true;
        const req = this.isEdit ? editAcct(data) : addTask(data);
        req
          .then((response) => {
            if (response.code !== "200") {
              this.$message.error(response.message || (this.isEdit ? "编辑失败" : "新增失败"));
              return;
            }
            // 新增模式下，如有本地缓存增项，需要拿到新分组 ID 后批量创建
            const pendingItems = this.isEdit ? [] : (this.extraItems || []).filter((i) => !i.id);
            const afterFinish = (msg) => {
              this.$message.success(msg || (this.isEdit ? "分组编辑成功" : "分组新增成功"));
              this.dialogVisible = false;
              this.handleList();
            };
            if (pendingItems.length === 0) {
              afterFinish();
              return;
            }
            // 尝试从响应中获取新分组 ID
            this.resolveNewGroupId(response, data)
              .then((newGroupId) => {
                if (!newGroupId) {
                  this.$message.warning("分组创建成功，但未获取到 ID，请手动进入该分组补充增项配置");
                  afterFinish(" ");
                  return;
                }
                return this.batchCreateExtraItems(newGroupId, pendingItems).then((failedCount) => {
                  if (failedCount > 0) {
                    this.$message.warning(`分组已创建，${pendingItems.length - failedCount}/${pendingItems.length} 个增项保存成功，剩余项请进入分组重试`);
                  } else {
                    this.$message.success(`分组与 ${pendingItems.length} 个增项均保存成功`);
                  }
                  this.dialogVisible = false;
                  this.handleList();
                });
              })
              .catch((err) => {
                console.log("submit pending extra items error:", err);
                afterFinish("分组已创建，增项保存异常请重试");
              });
          })
          .catch((err) => {
            console.log("submitForm error:", err);
            this.$message.error("操作异常");
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    // 从新增响应/列表兑现出新分组 ID
    resolveNewGroupId(response, data) {
      // 先尝试从响应体取
      try {
        if (response && response.data) {
          const raw = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
          if (raw && raw.id) return Promise.resolve(raw.id);
          if (typeof raw === "number" || typeof raw === "string") return Promise.resolve(raw);
        }
      } catch (_) {
        // ignore
      }
      // 兑底：查列表取同名同类型的分组
      return findUser({ groupName: data.groupName, type: data.type, page: 1, size: 20 })
        .then((res) => {
          try {
            const list = JSON.parse(res.data) || {};
            const rows = list.rows || [];
            const matched = rows.find((r) => r.groupName === data.groupName && r.type === data.type);
            return matched ? matched.id : "";
          } catch (e) {
            return "";
          }
        })
        .catch(() => "");
    },
    // 批量创建本地增项，返回失败数
    batchCreateExtraItems(groupId, items) {
      const tasks = items.map((item) =>
        addExtraItem({
          fieldName: item.fieldName,
          aliasName: item.aliasName,
          laborMergeGroup: item.laborMergeGroup || null,
          laborMergeName: item.laborMergeName || null,
          laborMergeMode: item.laborMergeMode || null,
          laborMergeRole: item.laborMergeRole || null,
          merchantAliasName: item.merchantAliasName || "",
          groupId,
          calcType: item.calcType,
          enabled: item.enabled === 0 ? 0 : 1,
          includeInMerchant: 0,
          unitPrice: this.needPriceInput(item.calcType) ? item.unitPrice : null,
          merchantUnitPrice: item.merchantAreaFlag === 1 && item.calcType !== "DIRECT" ? item.merchantUnitPrice : null,
          merchantPriceBookType: item.merchantAreaFlag === 1 && item.calcType !== "DIRECT" ? (item.merchantPriceBookType || null) : null,
          merchantPriceItemCode: item.merchantAreaFlag === 1 && item.calcType !== "DIRECT" && item.merchantPriceBookType
            ? String(item.merchantPriceItemCode || "BASE_AREA").trim().toUpperCase() : null,
          merchantStartQuantity: item.merchantAreaFlag === 1 && item.calcType !== "DIRECT" && !this.isFixedCalcType(item.calcType)
            ? (item.merchantStartQuantity != null ? Number(item.merchantStartQuantity) : null) : null,
          merchantTierThreshold: item.merchantAreaFlag === 1 && item.calcType !== "DIRECT" && !this.isFixedCalcType(item.calcType)
            ? (item.merchantTierThreshold != null ? Number(item.merchantTierThreshold) : null) : null,
          merchantTierBaseAmount: item.merchantAreaFlag === 1 && item.calcType !== "DIRECT" && !this.isFixedCalcType(item.calcType)
            ? (item.merchantTierBaseAmount != null ? Number(item.merchantTierBaseAmount) : null) : null,
          waterproofAreaRole: item.calcType === "AREA_ROLE"
            ? (item.waterproofAreaRole || null) : null,
          deliveryFeeCategory: item.deliveryFeeCategory || null,
          deliveryUnitPrice: item.calcType !== "DIRECT" && item.deliveryFeeCategory && item.deliveryFeeCategory !== "IGNORE"
            ? (item.deliveryUnitPrice != null ? Number(item.deliveryUnitPrice) : null) : null,
          threshold: this.needThresholdInput(item.calcType) ? (item.threshold != null && item.threshold !== '' ? Number(item.threshold) : null) : null,
          mutexGroup: item.mutexGroup || null,
          mutexPriority: item.mutexGroup ? (item.mutexPriority != null ? Number(item.mutexPriority) : 0) : 0,
          minAmount: item.calcType === "START_QUANTITY"
            ? null : (item.minAmount != null && item.minAmount !== '' ? Number(item.minAmount) : null),
          merchantAreaFlag: item.calcType === "AREA_ROLE" ? 0 : (item.merchantAreaFlag === 1 ? 1 : 0),
        })
          .then((res) => (res && res.code === "200" ? 0 : 1))
          .catch(() => 1)
      );
      return Promise.all(tasks).then((arr) => arr.reduce((s, n) => s + n, 0));
    },
    /* ====== 增项配置 ====== */
    loadExtraItems() {
      if (!this.formData.id) {
        this.extraItems = [];
        return;
      }
      this.extraLoading = true;
      findExtraItem(this.formData.id)
        .then((res) => {
          if (res.code === "200") {
            const data = res.data
              ? typeof res.data === "string"
                ? JSON.parse(res.data)
                : res.data
              : [];
            this.extraItems = Array.isArray(data) ? data : data.rows || [];
          } else {
            this.extraItems = [];
            this.$message.error("获取增项列表失败");
          }
        })
        .catch((err) => {
          console.log("loadExtraItems error:", err);
          this.extraItems = [];
        })
        .finally(() => {
          this.extraLoading = false;
        });
    },
    openExtraDialog(row) {
      this.extraForm = buildEmptyExtraForm();
      this.extraForm.groupId = this.formData.id;
      if (row && (row.id || row._localId)) {
        this.extraForm.id = row.id || "";
        this.extraForm._localId = row._localId || "";
        this.extraForm.fieldName = row.fieldName || "";
        this.extraForm.aliasName = row.aliasName || "";
        this.extraForm.laborMergeGroup = row.laborMergeGroup || "";
        this.extraForm.laborMergeName = row.laborMergeName || "";
        this.extraForm.laborMergeMode = row.laborMergeMode || "";
        this.extraForm.laborMergeRole = row.laborMergeRole || "";
        this.extraForm.merchantAliasName = row.merchantAliasName || "";
        this.extraForm.calcType = row.calcType || "DIRECT";
        this.extraForm.unitPrice = row.unitPrice != null ? Number(row.unitPrice) : 0;
        this.extraForm.merchantUnitPrice = row.merchantUnitPrice != null ? Number(row.merchantUnitPrice) : null;
        this.extraForm.merchantPriceBookType = row.merchantPriceBookType || "";
        this.extraForm.merchantPriceItemCode = row.merchantPriceBookType
          ? (row.merchantPriceItemCode || "BASE_AREA") : "";
        this.extraForm.merchantPriceItemCode = this.normalizePricingItemCode(
          this.extraForm.merchantPriceBookType, this.extraForm.merchantPriceItemCode);
        this.extraForm.merchantStartQuantity = row.merchantStartQuantity != null
          ? Number(row.merchantStartQuantity) : null;
        this.extraForm.merchantTierThreshold = row.merchantTierThreshold != null
          ? Number(row.merchantTierThreshold) : null;
        this.extraForm.merchantTierBaseAmount = row.merchantTierBaseAmount != null
          ? Number(row.merchantTierBaseAmount) : null;
        this.extraForm.merchantQuantityRule = this.extraForm.merchantTierThreshold != null && this.extraForm.merchantTierBaseAmount != null
          ? "TIER" : this.extraForm.merchantStartQuantity != null ? "START" : "NORMAL";
        this.extraForm.waterproofAreaRole = row.waterproofAreaRole || "";
        this.extraForm.deliveryFeeCategory = row.deliveryFeeCategory || "";
        this.extraForm.deliveryUnitPrice = row.deliveryUnitPrice != null ? Number(row.deliveryUnitPrice) : null;
        this.extraForm.threshold = row.threshold != null ? Number(row.threshold) : null;
        this.extraForm.enabled = row.enabled === 0 ? 0 : 1;
        this.extraForm.includeInMerchant = row.includeInMerchant === 1 ? 1 : 0;
        this.extraForm.merchantAreaFlag = row.merchantAreaFlag === 1 ? 1 : 0;
        this.extraForm.groupId = row.groupId || this.formData.id;
        this.extraForm.mutexGroup = row.mutexGroup || "";
        this.extraForm.mutexPriority = row.mutexPriority != null ? Number(row.mutexPriority) : 0;
        this.extraForm.minAmount = row.minAmount != null ? Number(row.minAmount) : null;
      }
      this.extraDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.extraForm) this.$refs.extraForm.clearValidate();
      });
    },
    // 商家独立计价不复用师傅金额。
    onMerchantAreaFlagChange(val) {
      this.extraForm.merchantAreaFlag = val ? 1 : 0;
      if (val) {
        this.extraForm.includeInMerchant = 0;
      }
      if (this.extraForm.calcType === "DIRECT") {
        this.extraForm.merchantUnitPrice = null;
        this.extraForm.merchantPriceBookType = "";
        this.extraForm.merchantPriceItemCode = "";
        this.extraForm.merchantStartQuantity = null;
        this.extraForm.merchantQuantityRule = "NORMAL";
        this.extraForm.merchantTierThreshold = null;
        this.extraForm.merchantTierBaseAmount = null;
      } else if (!val) {
        this.extraForm.merchantQuantityRule = "NORMAL";
        this.extraForm.merchantStartQuantity = null;
        this.extraForm.merchantTierThreshold = null;
        this.extraForm.merchantTierBaseAmount = null;
      }
    },
    submitExtra() {
      this.$refs.extraForm.validate((valid) => {
        if (!valid) return;
        const isLocal = !this.formData.id; // 新增分组模式
        const payload = {
          fieldName: this.extraForm.fieldName,
          aliasName: this.extraForm.aliasName,
          laborMergeGroup: this.extraForm.laborMergeGroup || null,
          laborMergeName: this.extraForm.laborMergeName || null,
          laborMergeMode: this.extraForm.laborMergeMode || null,
          laborMergeRole: this.extraForm.laborMergeRole || null,
          merchantAliasName: this.extraForm.merchantAliasName || "",
          groupId: this.extraForm.groupId || this.formData.id || "",
          calcType: this.extraForm.calcType,
          enabled: this.extraForm.enabled === 0 ? 0 : 1,
          includeInMerchant: 0,
          unitPrice: this.needPriceInput(this.extraForm.calcType) ? this.extraForm.unitPrice : null,
          merchantUnitPrice: this.extraForm.merchantAreaFlag === 1 && this.extraForm.calcType !== "DIRECT" ? this.extraForm.merchantUnitPrice : null,
          merchantPriceBookType: this.extraForm.merchantAreaFlag === 1 && this.extraForm.calcType !== "DIRECT" ? (this.extraForm.merchantPriceBookType || null) : null,
          merchantPriceItemCode: this.extraForm.merchantAreaFlag === 1 && this.extraForm.calcType !== "DIRECT" && this.extraForm.merchantPriceBookType
            ? String(this.extraForm.merchantPriceItemCode || "BASE_AREA").trim().toUpperCase() : null,
          merchantStartQuantity: this.extraForm.merchantAreaFlag === 1 && this.extraForm.calcType !== "DIRECT" && !this.isFixedCalcType(this.extraForm.calcType)
            && this.extraForm.merchantQuantityRule === "START"
            ? (this.extraForm.merchantStartQuantity != null ? Number(this.extraForm.merchantStartQuantity) : null) : null,
          merchantTierThreshold: this.extraForm.merchantAreaFlag === 1 && this.extraForm.calcType !== "DIRECT" && !this.isFixedCalcType(this.extraForm.calcType)
            && this.extraForm.merchantQuantityRule === "TIER"
            ? (this.extraForm.merchantTierThreshold != null ? Number(this.extraForm.merchantTierThreshold) : null) : null,
          merchantTierBaseAmount: this.extraForm.merchantAreaFlag === 1 && this.extraForm.calcType !== "DIRECT" && !this.isFixedCalcType(this.extraForm.calcType)
            && this.extraForm.merchantQuantityRule === "TIER"
            ? (this.extraForm.merchantTierBaseAmount != null ? Number(this.extraForm.merchantTierBaseAmount) : null) : null,
          waterproofAreaRole: this.extraForm.calcType === "AREA_ROLE"
            ? (this.extraForm.waterproofAreaRole || null) : null,
          deliveryFeeCategory: this.extraForm.deliveryFeeCategory || null,
          deliveryUnitPrice: this.extraForm.calcType !== "DIRECT" && this.extraForm.deliveryFeeCategory && this.extraForm.deliveryFeeCategory !== "IGNORE"
            ? (this.extraForm.deliveryUnitPrice != null ? Number(this.extraForm.deliveryUnitPrice) : null) : null,
          threshold: this.needThresholdInput(this.extraForm.calcType) ? (this.extraForm.threshold != null && this.extraForm.threshold !== '' ? Number(this.extraForm.threshold) : null) : null,
          mutexGroup: this.extraForm.mutexGroup || null,
          mutexPriority: this.extraForm.mutexGroup ? (this.extraForm.mutexPriority != null ? Number(this.extraForm.mutexPriority) : 0) : 0,
          minAmount: this.extraForm.calcType === "START_QUANTITY"
            ? null : (this.extraForm.minAmount != null && this.extraForm.minAmount !== '' ? Number(this.extraForm.minAmount) : null),
          merchantAreaFlag: this.extraForm.calcType === "AREA_ROLE" ? 0 : (this.extraForm.merchantAreaFlag === 1 ? 1 : 0),
        };
        // 新增分组模式：本地缓存增项
        if (isLocal) {
          if (this.extraForm._localId) {
            const idx = this.extraItems.findIndex((i) => i._localId === this.extraForm._localId);
            if (idx > -1) this.$set(this.extraItems, idx, { ...payload, _localId: this.extraForm._localId });
          } else {
            this.extraItems.push({ ...payload, _localId: `local_${Date.now()}_${Math.random()}` });
          }
          this.$message.success(this.extraForm._localId ? "增项已更新（将随分组一并保存）" : "增项已添加（将随分组一并保存）");
          this.extraDialogVisible = false;
          return;
        }
        // 编辑分组模式：调用后台接口
        if (this.extraForm.id) payload.id = this.extraForm.id;
        this.extraSubmitLoading = true;
        const req = this.extraForm.id ? updateExtraItem(payload) : addExtraItem(payload);
        req
          .then((res) => {
            if (res.code === "200") {
              this.$message.success(this.extraForm.id ? "增项编辑成功" : "增项添加成功");
              this.extraDialogVisible = false;
              this.loadExtraItems();
            } else {
              this.$message.error(res.message || "操作失败");
            }
          })
          .catch((err) => {
            console.log("submitExtra error:", err);
            this.$message.error("操作异常");
          })
          .finally(() => {
            this.extraSubmitLoading = false;
          });
      });
    },
    deleteExtra(row) {
      if (!row) return;
      const isLocal = !this.formData.id || !row.id;
      this.$confirm(`确定删除增项「${row.fieldName}」吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (isLocal) {
            // 本地缓存：直接从数组移除
            this.extraItems = this.extraItems.filter((i) =>
              row._localId ? i._localId !== row._localId : i !== row
            );
            this.$message.success("已移除");
            return;
          }
          deleteExtraItem(row.id)
            .then((res) => {
              if (res.code === "200") {
                this.$message.success("删除成功");
                this.loadExtraItems();
              } else {
                this.$message.error(res.message || "删除失败");
              }
            })
            .catch((err) => {
              console.log("deleteExtra error:", err);
              this.$message.error("删除异常");
            });
        })
        .catch(() => {});
    },
    toggleExtraEnabled(row, val) {
      const target = val ? 1 : 0;
      // 本地缓存（新增分组模式）直接修改
      if (!row.id) {
        this.$set(row, "enabled", target);
        return;
      }
      const payload = {
        id: row.id,
        fieldName: row.fieldName,
        aliasName: row.aliasName,
        laborMergeGroup: row.laborMergeGroup || null,
        laborMergeName: row.laborMergeName || null,
        laborMergeMode: row.laborMergeMode || null,
        laborMergeRole: row.laborMergeRole || null,
        merchantAliasName: row.merchantAliasName || "",
        groupId: row.groupId || this.formData.id,
        calcType: row.calcType,
        includeInMerchant: 0,
        unitPrice: this.needPriceInput(row.calcType) ? row.unitPrice : null,
        merchantUnitPrice: row.merchantAreaFlag === 1 && row.calcType !== "DIRECT" ? row.merchantUnitPrice : null,
        merchantPriceBookType: row.merchantAreaFlag === 1 && row.calcType !== "DIRECT" ? (row.merchantPriceBookType || null) : null,
        merchantPriceItemCode: row.merchantAreaFlag === 1 && row.calcType !== "DIRECT" && row.merchantPriceBookType
          ? String(row.merchantPriceItemCode || "BASE_AREA").trim().toUpperCase() : null,
        merchantStartQuantity: row.merchantAreaFlag === 1 && row.calcType !== "DIRECT" && !this.isFixedCalcType(row.calcType)
          ? (row.merchantStartQuantity != null ? Number(row.merchantStartQuantity) : null) : null,
        merchantTierThreshold: row.merchantAreaFlag === 1 && row.calcType !== "DIRECT" && !this.isFixedCalcType(row.calcType)
          ? (row.merchantTierThreshold != null ? Number(row.merchantTierThreshold) : null) : null,
        merchantTierBaseAmount: row.merchantAreaFlag === 1 && row.calcType !== "DIRECT" && !this.isFixedCalcType(row.calcType)
          ? (row.merchantTierBaseAmount != null ? Number(row.merchantTierBaseAmount) : null) : null,
        waterproofAreaRole: row.calcType === "AREA_ROLE"
          ? (row.waterproofAreaRole || null) : null,
        deliveryFeeCategory: row.deliveryFeeCategory || null,
        deliveryUnitPrice: row.calcType !== "DIRECT" && row.deliveryFeeCategory && row.deliveryFeeCategory !== "IGNORE"
          ? (row.deliveryUnitPrice != null ? Number(row.deliveryUnitPrice) : null) : null,
        threshold: this.needThresholdInput(row.calcType) ? (row.threshold != null && row.threshold !== '' ? Number(row.threshold) : null) : null,
        mutexGroup: row.mutexGroup || null,
        mutexPriority: row.mutexGroup ? (row.mutexPriority != null ? Number(row.mutexPriority) : 0) : 0,
        minAmount: row.calcType === "START_QUANTITY"
          ? null : (row.minAmount != null && row.minAmount !== '' ? Number(row.minAmount) : null),
        merchantAreaFlag: row.calcType === "AREA_ROLE" ? 0 : (row.merchantAreaFlag === 1 ? 1 : 0),
        enabled: target,
      };
      updateExtraItem(payload)
        .then((res) => {
          if (res.code === "200") {
            this.$set(row, "enabled", target);
            this.$message.success(target === 1 ? "已启用" : "已禁用");
          } else {
            this.$message.error(res.message || "状态切换失败");
          }
        })
        .catch((err) => {
          console.log("toggleExtraEnabled error:", err);
          this.$message.error("状态切换异常");
        });
    },
    // 互斥组颜色池
    getMutexGroupColor(group) {
      if (!group) return "#909399";
      const colors = ["#409eff", "#e6a23c", "#67c23a", "#f56c6c", "#909399", "#0bb89b", "#9b59b6", "#e74c3c"];
      let hash = 0;
      for (let i = 0; i < group.length; i++) {
        hash = group.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    },
    /* ====== 列表 ====== */
    handleView(row) {
      this.currentGroupId = row.id;
      this.detailVisible = true;
    },
    closeDetail() {
      this.detailVisible = false;
      this.currentGroupId = "";
    },
    handleSelectionChange() {},
    handleDelete() {
      const selections = this.$refs.crud.$refs.table.selection;
      if (!selections || selections.length === 0) {
        this.$message.warning("请先选择要删除的分组");
        return;
      }
      this.$confirm(`确定要删除选中的 ${selections.length} 个分组吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const ids = selections.map((item) => item.id).join(",");
          this.tableLoading = true;
          deleteAccountGroup(ids)
            .then((response) => {
              if (response.code === "200") {
                this.$message.success("删除成功");
                this.handleList();
              } else {
                this.$message.error("删除失败：" + (response.message || "未知错误"));
              }
            })
            .catch((error) => {
              console.log("删除分组异常:", error);
              this.$message.error("删除异常");
            })
            .finally(() => {
              this.tableLoading = false;
            });
        })
        .catch(() => {});
    },
    buildQuery(extra = {}) {
      return {
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchParams,
        ...extra,
      };
    },
    handleList(extra = {}) {
      this.tableLoading = true;
      findUser(this.buildQuery(extra))
        .then((res) => {
          const data = JSON.parse(res.data) || {};
          this.tableData = data.rows || [];
          this.page.total = data.total || 0;
        })
        .catch((err) => {
          console.log("handleList error:", err);
          this.tableData = [];
          this.page.total = 0;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    pageChange(page) {
      this.page.currentPage = page;
      this.handleList();
    },
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.handleList();
    },
    searchChange(params, done) {
      this.page.currentPage = 1;
      this.searchParams = {};
      if (params.groupName) this.searchParams.groupName = params.groupName;
      if (params.type) this.searchParams.type = params.type;
      this.handleList();
      if (typeof done === "function") done();
    },
    refreshChange(page) {
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.handleList();
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-dialog {
  ::v-deep .el-dialog__body {
    padding: 16px 24px 8px;
    max-height: 65vh;
    overflow-y: auto;
  }
}

.ag-section {
  margin-bottom: 16px;
  padding: 12px 16px 4px;
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-radius: 6px;

  &--base {
    background: linear-gradient(135deg, #f5f9ff 0%, #fafbfc 100%);
  }

  &--extra {
    background: linear-gradient(135deg, #fff7e6 0%, #fafbfc 100%);
    border-color: #faecd8;

    .ag-section__head i {
      color: #e6a23c;
    }
  }

  &__head {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    color: #303133;
    font-size: 14px;
    font-weight: 600;

    i {
      margin-right: 6px;
      color: #409eff;
      font-size: 16px;
    }
  }

  &__title {
    margin-right: 10px;
  }

  &__desc {
    margin-right: auto;
    color: #909399;
    font-size: 12px;
    font-weight: normal;
  }
}

.ag-fields {
  ::v-deep .el-form-item {
    margin-bottom: 14px;
  }
}

.ag-suffix {
  color: #909399;
  font-size: 12px;
  line-height: 32px;
  padding-right: 4px;
}

.ag-chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px 0 8px;

  &__hint {
    color: #909399;
    font-size: 12px;
    margin-right: 4px;
  }
}

.ag-chip {
  cursor: pointer;
  border-style: dashed;
  transition: all 0.2s;

  &:hover {
    color: #409eff;
    border-color: #409eff;
    background: #ecf5ff;
  }
}

.ag-empty {
  padding: 24px;
  text-align: center;
  color: #909399;
  font-size: 13px;
  background: #fafafa;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  margin-bottom: 12px;

  i {
    margin-right: 6px;
  }
}

/* 计算方式卡片选择器 */
.calc-type-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  width: 100%;
}

.calc-type-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    border-color: #c0c4cc;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }

  &.is-active {
    border-color: #409eff;
    background: linear-gradient(135deg, #ecf5ff 0%, #fff 70%);
    box-shadow: 0 2px 10px rgba(64, 158, 255, 0.18);
  }

  &__icon {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  &__body {
    flex: 1;
    min-width: 0;
    line-height: 1.4;
  }

  &__title {
    font-size: 13px;
    color: #303133;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__desc {
    font-size: 12px;
    color: #909399;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__check {
    position: absolute;
    top: 6px;
    right: 6px;
    color: #409eff;
    font-size: 16px;
  }
}

.form-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;

  i {
    color: #e6a23c;
    margin-right: 4px;
  }
}

/* 互斥配置区块 */
.mutex-section {
  margin-top: 8px;
  padding: 12px 16px 4px;
  background: linear-gradient(135deg, #f0f5ff 0%, #fafbfc 100%);
  border: 1px solid #d6e4ff;
  border-radius: 6px;

  &__head {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    color: #303133;
    font-size: 14px;
    font-weight: 600;

    i {
      margin-right: 6px;
      color: #409eff;
      font-size: 16px;
    }
  }

  &__title {
    margin-right: 10px;
  }

  &__desc {
    color: #909399;
    font-size: 12px;
    font-weight: normal;
  }

  &__tip {
    margin-bottom: 12px;
    padding: 8px 12px;
    font-size: 12px;
    color: #606266;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 4px;
    line-height: 1.6;

    i {
      color: #e6a23c;
      margin-right: 4px;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 14px;
  }
}
</style>
